// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: var(--sidebar-width);
  background: linear-gradient(180deg, var(--sidebar-bg-start) 0%, var(--sidebar-bg-end) 100%);
  border-right: none;
  padding: 24px 0;
  box-shadow: 4px 0 16px rgba(0,0,0,0.1);
  position: fixed;
  top: var(--header-height);
  left: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 100;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar.collapsed {
  width: var(--sidebar-collapsed);
  padding: 24px 0;
}

.sidebar-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.sidebar-section {
  display: flex;
  flex-direction: column;
}

.section-title {
  padding: 0 24px;
  margin-bottom: 8px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: rgba(74, 173, 227, 0.7); /* Cyan accent tinted */
  transition: opacity 0.2s;
  white-space: nowrap;
}

.sidebar.collapsed .section-title {
  opacity: 0;
  height: 0;
  margin: 0;
  overflow: hidden;
}

.menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu li a {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 24px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.65);
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  position: relative;
  white-space: nowrap;
}

.sidebar.collapsed .menu li a {
  padding: 12px 0;
  justify-content: center;
}

.menu li a::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: var(--accent);
  transform: scaleY(0);
  transition: transform 0.2s;
}

.menu li a:hover {
  background: rgba(255, 255, 255, 0.05);
  color: var(--white);
}

.menu li a:hover::before {
  transform: scaleY(1);
}

.menu li a.active {
  background: rgba(74, 173, 227, 0.15); /* Accent cyan semitransparent */
  color: var(--white);
  font-weight: 600;
}

.menu li a.active::before {
  transform: scaleY(1);
}

.menu .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s, color 0.2s;
  color: var(--accent); /* Blue icons as requested */
  min-width: 24px;
}

.menu li a:hover .icon,
.menu li a.active .icon {
  color: var(--accent);
}

.menu li a:hover .icon {
  transform: scale(1.1);
}

.menu .label {
  font-size: 14px;
  transition: opacity 0.2s, transform 0.2s;
  opacity: 1;
  transform: translateX(0);
}

.sidebar.collapsed .menu .label {
  opacity: 0;
  transform: translateX(-10px);
  position: absolute;
  pointer-events: none;
}

/* Custom Scrollbar for sidebar */
.sidebar::-webkit-scrollbar {
  width: 6px;
}

.sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25);
}

@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
    width: var(--sidebar-width) !important;
  }

  .sidebar.collapsed {
    transform: translateX(0);
    padding: 24px 0;
  }
  
  .sidebar.collapsed .menu li a {
    padding: 12px 24px;
    justify-content: flex-start;
  }
  
  .sidebar.collapsed .menu .label {
    opacity: 1;
    transform: translateX(0);
    position: static;
  }
  
  .sidebar.collapsed .section-title {
    opacity: 1;
    height: auto;
    margin-bottom: 8px;
  }
}

[data-theme="dark"] .menu li a {
  color: #ffffff;
}

[data-theme="dark"] .menu li a:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
}

[data-theme="dark"] .menu li a.active,
[data-theme="dark"] .menu li a.active .icon {
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,2FAA2F;EAC3F,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,yBAAyB;EACzB,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gGAAgG;AAClG;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B,EAAE,uBAAuB;EACvD,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oCAAoC,EAAE,gCAAgC;EACtE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,oBAAoB,EAAE,4BAA4B;EAClD,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,4BAA4B;IAC5B,sCAAsC;EACxC;;EAEA;IACE,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":[".sidebar {\n  width: var(--sidebar-width);\n  background: linear-gradient(180deg, var(--sidebar-bg-start) 0%, var(--sidebar-bg-end) 100%);\n  border-right: none;\n  padding: 24px 0;\n  box-shadow: 4px 0 16px rgba(0,0,0,0.1);\n  position: fixed;\n  top: var(--header-height);\n  left: 0;\n  bottom: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  z-index: 100;\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar.collapsed {\n  width: var(--sidebar-collapsed);\n  padding: 24px 0;\n}\n\n.sidebar-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.sidebar-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.section-title {\n  padding: 0 24px;\n  margin-bottom: 8px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  color: rgba(74, 173, 227, 0.7); /* Cyan accent tinted */\n  transition: opacity 0.2s;\n  white-space: nowrap;\n}\n\n.sidebar.collapsed .section-title {\n  opacity: 0;\n  height: 0;\n  margin: 0;\n  overflow: hidden;\n}\n\n.menu {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.menu li a {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 12px 24px;\n  text-decoration: none;\n  color: rgba(255, 255, 255, 0.65);\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  position: relative;\n  white-space: nowrap;\n}\n\n.sidebar.collapsed .menu li a {\n  padding: 12px 0;\n  justify-content: center;\n}\n\n.menu li a::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  background: var(--accent);\n  transform: scaleY(0);\n  transition: transform 0.2s;\n}\n\n.menu li a:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--white);\n}\n\n.menu li a:hover::before {\n  transform: scaleY(1);\n}\n\n.menu li a.active {\n  background: rgba(74, 173, 227, 0.15); /* Accent cyan semitransparent */\n  color: var(--white);\n  font-weight: 600;\n}\n\n.menu li a.active::before {\n  transform: scaleY(1);\n}\n\n.menu .icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s, color 0.2s;\n  color: var(--accent); /* Blue icons as requested */\n  min-width: 24px;\n}\n\n.menu li a:hover .icon,\n.menu li a.active .icon {\n  color: var(--accent);\n}\n\n.menu li a:hover .icon {\n  transform: scale(1.1);\n}\n\n.menu .label {\n  font-size: 14px;\n  transition: opacity 0.2s, transform 0.2s;\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.sidebar.collapsed .menu .label {\n  opacity: 0;\n  transform: translateX(-10px);\n  position: absolute;\n  pointer-events: none;\n}\n\n/* Custom Scrollbar for sidebar */\n.sidebar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 4px;\n}\n\n.sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n    transform: translateX(-100%);\n    width: var(--sidebar-width) !important;\n  }\n\n  .sidebar.collapsed {\n    transform: translateX(0);\n    padding: 24px 0;\n  }\n  \n  .sidebar.collapsed .menu li a {\n    padding: 12px 24px;\n    justify-content: flex-start;\n  }\n  \n  .sidebar.collapsed .menu .label {\n    opacity: 1;\n    transform: translateX(0);\n    position: static;\n  }\n  \n  .sidebar.collapsed .section-title {\n    opacity: 1;\n    height: auto;\n    margin-bottom: 8px;\n  }\n}\n\n[data-theme=\"dark\"] .menu li a {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .menu li a:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme=\"dark\"] .menu li a.active,\n[data-theme=\"dark\"] .menu li a.active .icon {\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
